import { render } from "./SearchResultsOpportunity.vue?vue&type=template&id=32e520db&scoped=true"
import script from "./SearchResultsOpportunity.vue?vue&type=script&lang=js"
export * from "./SearchResultsOpportunity.vue?vue&type=script&lang=js"

import "./SearchResultsOpportunity.vue?vue&type=style&index=0&id=32e520db&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e520db"]])

export default __exports__